export default (num: unknown): num is number =>
  typeof num === 'number' && !isNaN(num);
